export const idTypesConstants = {
  GET_IDTYPES_REQUEST: "GET_IDTYPES_REQUEST",
  GET_IDTYPES_SUCCESS: "GET_IDTYPES_SUCCESS",
  GET_IDTYPES_FAILURE: "GET_IDTYPES_FAILURE",
  GET_IDTYPES_RESET: "GET_IDTYPES_RESET",

  VIEW_IDTYPE_REQUEST: "VIEW_IDTYPE_REQUEST",
  VIEW_IDTYPE_SUCCESS: "VIEW_IDTYPE_SUCCESS",
  VIEW_IDTYPE_FAILURE: "VIEW_IDTYPE_FAILURE",
  VIEW_IDTYPE_RESET: "VIEW_IDTYPE_RESET",

  ADD_IDTYPE_REQUEST: "ADD_IDTYPE_REQUEST",
  ADD_IDTYPE_SUCCESS: "ADD_IDTYPE_SUCCESS",
  ADD_IDTYPE_FAILURE: "ADD_IDTYPE_FAILURE",
  ADD_IDTYPE_RESET: "ADD_IDTYPE_RESET",

  EDIT_IDTYPE_REQUEST: "EDIT_IDTYPE_REQUEST",
  EDIT_IDTYPE_SUCCESS: "EDIT_IDTYPE_SUCCESS",
  EDIT_IDTYPE_FAILURE: "EDIT_IDTYPE_FAILURE",
};
